import React from "react";
import { StickyNote } from "lucide-react";
import { NoteList } from "../components/NoteList";

export default function Note() {
  return (
    <div data-testid="note-page">
      <div className="mb-5">
        <h1 className="text-xl sm:text-2xl font-head font-bold flex items-center gap-2"><StickyNote size={22} className="text-primary" /> Note</h1>
        <p className="text-sm text-muted-foreground">Appunti personali, anche vocali (trascritti in automatico). Solo tu puoi vederli.</p>
      </div>
      <NoteList />
    </div>
  );
}
